import { useEffect, useState } from 'react'

import { makePostMissionAnswer, makePutMissionAnswer } from '../../../../main/usecases/mission-answer/post-mission-answer-factory'
import { useGame, useGameWrapper, usePage } from '../../../contexts'
import { customTheme } from '../../../styles/theme'
import { getAssetUrl } from '../../../utils/assets_helpers'
import { addAllowFullScreen, replaceInstructionsTags } from '../../../utils/mission_helpers'
import { getTeam } from '../../../utils/team_helpers'
import { Container, Image, Instructions } from '../styles'
import { YoutubeCarousel } from '../../youtube_carousel'
import {
  Choices,
  Options
} from './styles'
import ItemOption from './item'
import { MissionType } from '../../../../domain/enum/mission-type.enum'
import { t } from '../../../adapters/translate/translate'
import { replaceHtmlEntity } from '../../../utils/text_replace'

const MultipleChoiceMission = () => {
  const [instructions, setInstructions] = useState<string|null>('')
  const [uuid, setUuid] = useState<string>('')
  const [options, setOptions] = useState<string[]>([])
  const [selectedOptionsId, setSelectedOptionsId] = useState<string[]>([])
  const [numberAlternatives, setNumberAlternatives] = useState<number>(1)
  const [numberMinSelections, setNumberMinSelections] = useState<number>(1)
  const [borderColor, setBorderColor] = useState<string>('')
  const [status, setStatus] = useState<string>('')
  let flag = true

  const [color, setColor] = useState<any>('#fff')
  const team = getTeam()
  const { game } = useGame()

  const { timeout, attempts, currentMission, submitCallback, doSubmit, submitButtonIsEnabled, handleToggleStatusSubmitButton, setTimePaused } = useGameWrapper()
  const { baseColor } = usePage()

  function loadComponent () {
    setNumberAlternatives(Number(currentMission?.options?.maxSelections || currentMission?.options?.answers?.length))
    setNumberMinSelections(Number(currentMission?.options?.minSelections))

    setBorderColor(baseColor || currentMission?.baseColor || '')
    const answers = currentMission?.options?.answers || {}
    const opt: string[] = []
    Object.keys(answers).map(key => (
      opt.push(answers[key]?.description)
    ))
    setOptions(opt)
  }

  async function initAnswer () {
    try {
      if (flag && team.id && currentMission?.type !== MissionType.PICTURE) {
        flag = false
        const res = await makePostMissionAnswer().post({
          mission: currentMission?.uuid,
          team: team.id
        })
        setUuid(res['@id'] || '')
      }
    } catch (error) {
      console.error('OpenAnswerMission.sendAnswer', error)
    }
  }

  async function sendAnswer () {
    try {
      if (team.id) {
        let answersToSend:any = selectedOptionsId
        const missionAttempts = currentMission?.options?.attempts

        if (missionAttempts && missionAttempts > 1) {
          answersToSend = [...answersToSend, { attempts: (missionAttempts - attempts) + 1 }]
        }

        const res = await makePutMissionAnswer(uuid).update({
          answer: answersToSend,
          status: timeout ? 'timeout' : status
        })
        setSelectedOptionsId([])
        return res
      }
    } catch (error) {
      console.error('OpenAnswerMission.sendAnswer', error)
      setSelectedOptionsId([])
    }
  }

  const ensureItemOnList = (id: string) => {
    return selectedOptionsId.includes(id)
  }

  const handleToggleItem = (id: string) => {
    let itemGroup = [...selectedOptionsId]
    if (ensureItemOnList(id)) {
      itemGroup = itemGroup.filter(item => item !== id)
    } else {
      if (!(selectedOptionsId.length >= numberAlternatives)) {
        itemGroup.push(id)
      }
    }
    setSelectedOptionsId(itemGroup)
  }

  function handleEnableButton () {
    if (selectedOptionsId.length >= numberMinSelections && selectedOptionsId.length > 0) {
      handleToggleStatusSubmitButton(true)
    } else {
      handleToggleStatusSubmitButton(false)
    }
  }

  useEffect(() => {
    handleEnableButton()
  }, [selectedOptionsId])

  useEffect(() => {
    if (doSubmit && submitButtonIsEnabled) {
      submitCallback(sendAnswer)
    }
  }, [doSubmit, submitButtonIsEnabled])

  useEffect(() => {
    initAnswer()
  }, [JSON.stringify(currentMission?.uuid)])

  useEffect(() => {
    loadComponent()
    setSelectedOptionsId([])
    setStatus('responded')
    setSelectedOptionsId([])
    if (!currentMission) return
    const formattedInstructions = replaceInstructionsTags({ mission: currentMission, points: currentMission.pointsIfCorrect })
    setInstructions(addAllowFullScreen(formattedInstructions))
  }, [currentMission])

  useEffect(() => {
    if (timeout) {
      submitCallback(sendAnswer)
      setSelectedOptionsId([])
    }
  }, [timeout])

  useEffect(() => {
    setTimePaused(false)
    if (game) { setColor(game?.textColor || '#fff') }
  }, [game])

  useEffect(() => {
    const div = document.getElementById('instructions')
    if (div) {
      div.innerHTML = replaceHtmlEntity(div.innerHTML)
    }
  }, [instructions])

  return (
    <Container>
      { currentMission?.icon && <Image src={getAssetUrl('icon', String(currentMission?.icon))} /> }
      {!!instructions && <Instructions id="instructions" dangerouslySetInnerHTML={
        { __html: instructions }
      } />}

      {currentMission?.options.video && <YoutubeCarousel videos={['https://www.youtube.com/embed/E7wJTI-1dvQ']}/>}

      <Choices style={{ color }}>
        {t('Select below')}:
      </Choices>

      <Options>
        {options.map(option => (
          <ItemOption
            key={option}
            selected={ensureItemOnList(option)}
            handleClick={() => handleToggleItem(option)}
            bg={borderColor || customTheme.colors.green}
            borderColor={borderColor || customTheme.colors.green}
            color="#fff"
          >
            {option}
          </ItemOption>
        ))}
      </Options>
    </Container>
  )
}

export default MultipleChoiceMission
